import React from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  main: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  },
});
const Homepage = ({ finished }: { finished?: boolean }) => {
  const classes = useStyles();
  return (
    <main className={classes.main}>
      <h1>deeptrue-survey</h1>
      <p>
        {' '}
        {finished
          ? 'The survey is no longer active. Data collection for this survey has been completed. '
          : 'Please ensure that you have proper link'}
      </p>
    </main>
  );
};

export default Homepage;
